import { render, staticRenderFns } from "./sellCard.vue?vue&type=template&id=48fe1acf&scoped=true&"
import script from "./sellCard.vue?vue&type=script&lang=js&"
export * from "./sellCard.vue?vue&type=script&lang=js&"
import style0 from "./sellCard.vue?vue&type=style&index=0&id=48fe1acf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fe1acf",
  null
  
)

export default component.exports